<div [ngStyle]="{ 'display' : this.procedureService.procedureNavaidAssociationActive ? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  class="active">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div>
            <table>
              <thead>
                <tr>
                  <th scope="col" *ngFor="let column of this.procedureService.procedureNavaidModel?.columns" (click)="pNASelectedCollumm(column.id)">
                    {{column.description}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of this.procedureService.procedureNavaidModel?.rows; let i = index">
                  <td *ngFor="let column of this.procedureService.procedureNavaidModel?.columns; let j = index">
                    <div *ngIf="column.id == '-1'" [ngStyle]="{'background-color': row['selected']? 'red' : ''}">
                      {{row[column.description]}}
                    </div>
                    <div *ngIf="column.id != '-1'">
                      <input
                        type="checkbox"
                        id="{{i}}_{{j}}"
                        name="{{i}}_{{j}}"
                        [(ngModel)]="row[column.id]"
                        [checked]="row[column.id]"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button class="blue" (click)="this.pnaAddNavaids();">Add Selected NavAids</button>
      <button class="blue" (click)="this.pnaAddProcedures();">Add Selected Procedures</button>
      <button class="blue"(click)="save()">Save</button>
    </div>
  </form>
</div>
